// @flow
import React from 'react';
import { Redirect } from 'react-router-dom';

/**
 * Detail pages are permanently deprecated: every visit to
 *   /(used-cars|new-cars-in-stock|car-leasing-deals)/:make/:model/:name/:id
 * is redirected up to the corresponding results page. The server issues a
 * 301 for hard navigations (see App/server/server.js); this component
 * handles SPA / client-side navigations by rendering a react-router
 * `<Redirect>` so no full page load is needed.
 *
 * `search` is preserved so tracking params (e.g. utm_*) survive.
 */
const DetailRedirect = ({ match, location }: Object) => {
  const { section, make, model } = match.params;
  const search = (location && location.search) || '';
  const target = `/${section}/${make}/${model}${search}`;
  return <Redirect to={target} />;
};

export default DetailRedirect;



// WEBPACK FOOTER //
// ./src/Detail/DetailRedirect.js